import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { HistoryView } from "../views/HistoryView";
import { NewProjectView } from "../views/NewProjectView";
import { ProjectView } from "../views/ProjectView";
import { PrintView } from "../views/PrintView";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/project/:id/print" element={<PrintView />} />
        <Route
          path="*"
          element={
            <>
              <header className="topbar no-print">
                <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
                  <h1>📚 AI Study Material Generator</h1>
                </Link>
                <Link className="btn" to="/new">
                  + New Project
                </Link>
              </header>
              <Routes>
                <Route path="/" element={<HistoryView />} />
                <Route path="/new" element={<NewProjectView />} />
                <Route path="/project/:id" element={<ProjectView />} />
              </Routes>
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
